/** Formatierungs-Helfer (deutsch, Zeitstempel in Millisekunden). */

const dateTimeFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('de-DE', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return dateTimeFormatter.format(new Date(ms));
}

export function formatDate(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return dateFormatter.format(new Date(ms));
}

export function formatTime(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return timeFormatter.format(new Date(ms));
}

/** "vor 3 Min." — grob, reicht für Listen. */
export function formatRelative(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  const diff = Date.now() - ms;
  if (diff < 0) return `in ${formatDuration(-diff)}`;
  if (diff < 45_000) return 'gerade eben';
  return `vor ${formatDuration(diff)}`;
}

function formatDuration(ms: number): string {
  const minutes = Math.round(ms / 60_000);
  if (minutes < 60) return `${minutes} Min.`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} Std.`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} Tg.`;
  return `${Math.round(days / 30)} Mon.`;
}

/** Millisekunden → Wert für `<input type="date">` (lokale Zeitzone). */
export function toDateInput(ms: number | null): string {
  if (ms === null) return '';
  const date = new Date(ms);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/** Wert aus `<input type="date">` → Millisekunden (lokale Mitternacht) oder null. */
export function fromDateInput(value: string): number | null {
  if (value.trim() === '') return null;
  const parsed = Date.parse(`${value}T00:00:00`);
  return Number.isNaN(parsed) ? null : parsed;
}

/** Fällig und noch nicht abgeschlossen? */
export function isOverdue(dueAt: number | null, status: string): boolean {
  if (dueAt === null) return false;
  if (status === 'done' || status === 'cancelled') return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dueAt < today.getTime();
}

export function initials(name: string): string {
  const trimmed = name.trim();
  if (trimmed === '') return '?';
  const parts = trimmed.split(/\s+/).filter((p) => p !== '');
  const first = parts[0];
  if (first === undefined) return '?';
  const last = parts.length > 1 ? parts[parts.length - 1] : undefined;
  if (last === undefined || last === first) return first.slice(0, 2).toUpperCase();
  return `${first.slice(0, 1)}${last.slice(0, 1)}`.toUpperCase();
}

/** Nutzlast als lesbares JSON. */
export function jsonText(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2) ?? String(value);
  } catch {
    return String(value);
  }
}

/** Anzeigewert für Historien-Felder (null → "—"). */
export function historyValue(value: string | null): string {
  if (value === null || value === '') return '—';
  return value;
}
